import { InformationModal, DefaultPrimaryButton } from "@/styles/globalstyles";
import {
  Modal,
  Box,
  Typography,
  Divider,
  TextField,
  Button,
  Switch,
} from "@mui/material";
import CloseButton from "../buttons/CloseButton";
import type { Master } from "@/api/masterService";
import { useEffect, useState } from "react";

interface SaveMasterModalProps {
  open: boolean;
  handleClose: () => void;
  selectedMaster?: Master;
  handleAddMaster: (data: Master) => void;
  handleEditMaster: (data: Master) => void;
}

const SaveMasterModal = ({
  open,
  handleClose,
  selectedMaster,
  handleAddMaster,
  handleEditMaster,
}: SaveMasterModalProps) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [formData, setFormData] = useState<Master>({
    id: 0,
    name: "",
    description: "",
    is_active: true,
    created_at: "",
    created_by: "",
    updated_at: "",
    updated_by: "",
  });

  useEffect(() => {
    if (selectedMaster) {
      setFormData({
        id: selectedMaster.id,
        name: selectedMaster.name,
        description: selectedMaster.description,
        is_active: selectedMaster.is_active,
        created_at: selectedMaster.created_at,
        created_by: selectedMaster.created_by,
        updated_at: selectedMaster.updated_at,
        updated_by: selectedMaster.updated_by,
      });
    }
  }, [selectedMaster]);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.name) {
      newErrors.name = "กรุณากรอกชื่อ";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAdd = () => {
    if (!validateForm()) return;
    handleAddMaster(formData);
    onClose();
  };

  const handleEdit = () => {
    if (!validateForm()) return;
    handleEditMaster(formData);
    onClose();
  };

  const onClose = () => {
    setFormData({
      id: 0,
      name: "",
      description: "",
      is_active: true,
      created_at: "",
      created_by: "",
      updated_at: "",
      updated_by: "",
    });
    setErrors({});
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...InformationModal, maxHeight: "90vh" }}>
        <CloseButton onClick={onClose} />
        <Typography variant="h2">
          {selectedMaster ? "แก้ไข Master" : "เพิ่ม Master"}
        </Typography>
        <Box p={1}>
          <Divider sx={{ my: 1 }} />
          <TextField
            fullWidth
            label={
              <>
                ชื่อ{" "}
                <Typography component="span" color="error.main">
                  *
                </Typography>
              </>
            }
            variant="outlined"
            sx={{ mt: 2 }}
            value={formData.name}
            error={!!errors.name}
            helperText={errors.name}
            onChange={(e) => {
              setFormData({
                ...formData,
                name: e.target.value,
              });
              if (errors.name) {
                setErrors({ ...errors, name: "" });
              }
            }}
          />
          <TextField
            fullWidth
            label={<>คำอธิบาย</>}
            variant="outlined"
            sx={{ mt: 2 }}
            value={formData.description}
            onChange={(e) => {
              setFormData({ ...formData, description: e.target.value });
            }}
          />
        </Box>
        {selectedMaster && (
          <Box mt={2} display="flex" alignItems="center" gap={1}>
            <Switch
              checked={formData.is_active}
              onChange={(e) =>
                setFormData({ ...formData, is_active: e.target.checked })
              }
            />
            <Typography fontWeight="bold">Active</Typography>
          </Box>
        )}
        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="contained"
            sx={DefaultPrimaryButton}
            onClick={selectedMaster ? handleEdit : handleAdd}
          >
            บันทึก
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveMasterModal;
